import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { useNavigate, useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import { getProductMoneda } from '../moneda';
import { getItemOptions, isCustomPrice, isStockNotRequired, getStoredCartItems, serializeCartItems } from '../productStock';
import { loadFavorites, toggleFavorite } from '../favoritesStore';
import ProductDescription from '../ProductDescription/ProductDescription';
import ProductMedia, { getProductMediaSources, isVideoMedia } from '../ProductMedia/ProductMedia';

export default function Detail() {
    const navigate = useNavigate();
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const [favoritesAuthenticated, setFavoritesAuthenticated] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
    const location = useLocation();
    const itemOptions = getItemOptions(producto || {});
    const stockNotRequired = isStockNotRequired(producto || {});
    const selectedOption = itemOptions[selectedItemIndex] || null;
    const selectedItem = selectedOption?.label || '';
    const selectedItemStock = stockNotRequired
        ? Number.POSITIVE_INFINITY
        : itemOptions.length > 0
        ? (selectedOption?.stock ?? 0)
        : Math.max(0, Number(producto?.stock) || 0);

    useEffect(() => {
        cargarProductos();
        cargarContacto();
        cargarFavoritos();
        cargarCategoria()
    }, []);
    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };
    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(Array.isArray(data.contacto) ? [...data.contacto].reverse()[0] || {} : {});
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                console.log(data.productos)
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
                setLoading(true);
            });
    };


    const cargarFavoritos = async () => {
        const result = await loadFavorites();
        setFavoritos(result.favoritos);
        setFavoritesAuthenticated(result.authenticated);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
        const productMedia = getProductMediaSources(product || {});
        const firstImageIndex = productMedia.findIndex((mediaUrl) => !isVideoMedia(mediaUrl));
        setSelectedMediaIndex(firstImageIndex >= 0 ? firstImageIndex : 0);
    }, [idProducto, productos]);

    useEffect(() => {
        const currentItemOptions = getItemOptions(producto || {});

        if (currentItemOptions.length === 0) {
            setSelectedItemIndex(0);
            return;
        }

        if (isStockNotRequired(producto || {})) {
            setSelectedItemIndex(0);
            return;
        }

        const firstAvailableIndex = currentItemOptions.findIndex((item) => item.stock > 0);
        if (firstAvailableIndex !== -1) {
            setSelectedItemIndex(firstAvailableIndex);
        } else {
            setSelectedItemIndex(0);
        }
    }, [producto]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);




    async function handleCompartirClick() {
        const productUrl = window.location.href;

        try {
            await navigator.clipboard.writeText(productUrl);
            toast.success('Link copiado', { autoClose: 900 });
        } catch (error) {
            const textarea = document.createElement('textarea');
            textarea.value = productUrl;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();

            const copied = document.execCommand('copy');
            document.body.removeChild(textarea);

            if (copied) {
                toast.success('Link copiado', { autoClose: 900 });
            } else {
                toast.error('No se pudo copiar el link', { autoClose: 1200 });
            }
        }
    }

    const handleWhatsappMessage = () => {
        const phoneNumber = contactos?.telefono;
        const title = producto?.titulo || '';
        const formattedPrice = Number(producto?.precio).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const priceText = isCustomPrice(producto) ? 'Personalizable' : `${getProductMoneda(producto)} ${formattedPrice}`;
        const item = selectedItem;

        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${title}*\n     ${item}\n     ${priceText}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };

    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };




    const addToCart = (selectedItem) => {
        if (producto) {
            if (itemOptions.length > 0 && !selectedItem) {
                toast.error('Selecciona una talla', { autoClose: 500 });
                return;
            }

            if (!stockNotRequired && selectedItemStock < 1) {
                toast.error('No hay stock', { autoClose: 400 });
                return;
            }
            const cart = getStoredCartItems();
            const existingItemIndex = cart.findIndex(item =>
                item.idProducto === producto.idProducto && item.item === selectedItem
            );

            const quantityInCart = existingItemIndex !== -1 ? cart[existingItemIndex].cantidad : 0;
            if (!stockNotRequired && quantityInCart + cantidad > selectedItemStock) {
                toast.error('La cantidad supera el stock disponible de esa talla', { autoClose: 700 });
                return;
            }

            if (existingItemIndex !== -1) {
                const existingItem = cart[existingItemIndex];
                const updatedCantidad = existingItem.cantidad + cantidad;
                cart[existingItemIndex] = { ...existingItem, cantidad: updatedCantidad };
            } else {
                cart.push({ idProducto: producto.idProducto, item: selectedItem, cantidad });
            }
            localStorage.setItem('cart', JSON.stringify(serializeCartItems(cart)));
            cargarProductos();
            toast.success('Producto agregado', { autoClose: 400 });
            setTimeout(() => {
                window.location.reload();

            }, 600);
        }
    };

    const incrementCantidad = () => {
        if (!stockNotRequired && selectedItemStock > 0 && cantidad >= selectedItemStock) {
            toast.error(itemOptions.length > 0 ? 'No puedes superar el stock de esa talla' : 'No puedes superar el stock disponible', { autoClose: 500 });
            return;
        }
        setCantidad(cantidad + 1);
    };

    const decrementCantidad = () => {
        if (cantidad > 1) {
            setCantidad(cantidad - 1);
        }
    };


    const agregarAFavoritos = async (idProducto) => {
        const nextFavoritos = await toggleFavorite(idProducto, favoritos, favoritesAuthenticated);
        setFavoritos(nextFavoritos);
    };

    if (!producto) {
        return <DetailLoading />;
    }

    const mediaSources = getProductMediaSources(producto);
    const selectedMedia = mediaSources[selectedMediaIndex] || mediaSources[0] || '';
    const selectedMediaIsVideo = isVideoMedia(selectedMedia);


    return (


        <div className="detail">
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>

                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>


            </div>
            <div className="detail-contain">
                <div className="productDetailMedia">
                    <div id="swiperDetail" className="productDetailMainMedia">
                        <ProductMedia
                            src={selectedMedia}
                            alt={producto.titulo}
                            className="productMediaDetail"
                            controls={selectedMediaIsVideo}
                            muted={false}
                            onClick={selectedMediaIsVideo ? undefined : () => {
                                setModalImage(selectedMedia);
                                setIsModalOpen(true);
                            }}
                        />
                    </div>
                    {mediaSources.length > 1 && (
                        <div className="productDetailThumbs">
                            {mediaSources.map((mediaUrl, index) => (
                                <button
                                    type="button"
                                    key={`${mediaUrl}-${index}`}
                                    className={`productDetailThumb ${selectedMediaIndex === index ? 'selected' : ''}`}
                                    onClick={() => setSelectedMediaIndex(index)}
                                    aria-label={`Ver archivo ${index + 1}`}
                                >
                                    <ProductMedia src={mediaUrl} alt={`${producto.titulo} ${index + 1}`} className="productMediaThumb" muted />
                                    {isVideoMedia(mediaUrl) && <span className="productDetailVideoBadge">Video</span>}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {
                            categorias
                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                .map(categoriaFiltrada => (
                                    <h4>  <FontAwesomeIcon icon={faStar} />{categoriaFiltrada.categoria}</h4>

                                ))
                        }
                        {!stockNotRequired && producto.stock >= 1 ? (
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '0px 10px', borderRadius: '6px' }}>
                                Stock total {producto.stock}
                            </h4>
                        ) : !stockNotRequired && producto.stock <= 0 ? (
                            <h4 style={{ color: 'red', backgroundColor: '#ffc1c1', padding: '0px 10px', borderRadius: '6px' }}>Agotado</h4>
                        ) : !stockNotRequired ? (

                            <h4>{producto.stock}</h4>
                        ) : null}
                    </div>

                    <div className='deFLexPrice'>
                        <h5 className="price">
                            {isCustomPrice(producto)
                                ? 'Personalizable'
                                : `${getProductMoneda(producto)} ${String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`}

                        </h5>

                        {
                            (!isCustomPrice(producto) && producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined) && (
                                <h5 className='precioTachadoDetail'> {getProductMoneda(producto)} {`${producto?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                            )
                        }


                    </div>
                    <ProductDescription text={producto.descripcion} />
                    <div className='itemsDetail'>
                        {producto && itemOptions.length > 0 && itemOptions.map((item, index) => (
                            item?.label && (
                                <label key={index}>
                                    <input
                                        type="radio"
                                        name="talle"
                                        value={item.label}
                                        checked={selectedItemIndex === index}
                                        onChange={() => handleSelectionChange(index)}
                                        disabled={!stockNotRequired && item.stock <= 0}
                                    />
                                    {stockNotRequired ? item.label : `${item.label} (${item.stock})`}
                                </label>
                            )
                        ))}
                    </div>

                    {!stockNotRequired && itemOptions.length > 0 && selectedItem && (
                        <p style={{ marginTop: '10px', color: selectedItemStock > 0 ? 'green' : 'red' }}>
                            Stock disponible en {selectedItem}: {selectedItemStock}
                        </p>
                    )}


                    <div className='deFlexCart'>
                        <button onClick={decrementCantidad}>-</button>
                        <span>{cantidad}</span>
                        <button onClick={incrementCantidad}>+</button>
                    </div>
                    <div className='deFlexGoTocart'>
                        <button onClick={() => addToCart(selectedItem)} className='btnAdd'>Agregar  <FontAwesomeIcon icon={faShoppingCart} />  </button>
                        <button className="wpp" onClick={handleWhatsappMessage}>
                            WhatsApp
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <ProductMedia src={modalImage} alt={producto.titulo} className="productMediaModal" controls />
            </Modal>
        </div>

    )
}





